import { CartId } from 'lib/types'
import { RootState } from 'lib/core/data/reducer'

export const getShippingAddress = (cartId: CartId) => (state: RootState) => {
  const slice = state.quote.setShippingAddress[cartId ?? ''] ?? {}
  return slice
}
